// extracted by mini-css-extract-plugin
export var footer = "_pw-5";
export var fulfillmentInput = "_pw-0";
export var shipDateInput = "_pw-1";
export var shipmentModal = "_pw-2";
export var shipmentModalContent = "_pw-3";
export var tableContainer = "_pw-4";